import React, { useState } from 'react';
import {
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  IconButton,
  Box,
  Grid,
  Divider
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import ApiServices from '../../../Utils/ApiServices/ApiServices';
import { getDecryptedAccessToken } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';

const BenefitsDetails = ({ benefits }) => {
  const accessToken = getDecryptedAccessToken();
  const [formData, setFormData] = useState({
    ...benefits,
    is_for_appointment: benefits.is_for_appointment === '1',
    active: benefits.active === '1',
    description: typeof benefits.description === 'string' ? JSON.parse(benefits.description) : benefits.description,
    faqs: typeof benefits.faqs === 'string' ? JSON.parse(benefits.faqs) : benefits.faqs,
    age_based_pricing: typeof benefits.age_based_pricing === 'string' ? JSON.parse(benefits.age_based_pricing) : benefits.age_based_pricing || [],

  });
  const [selectedImage, setSelectedImage] = useState(null);
const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      setSelectedImage(reader.result);
    };
    reader.readAsDataURL(file);
  }
};


  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleDescriptionChange = (index, value) => {
    const updated = [...formData.description];
    updated[index] = value;
    setFormData({ ...formData, description: updated });
  };

  const handleFAQChange = (index, key, value) => {
    const updated = [...formData.faqs];
    updated[index][key] = value;
    setFormData({ ...formData, faqs: updated });
  };

  const addDescription = () => {
    setFormData({ ...formData, description: [...formData.description, ''] });
  };

  const removeDescription = (index) => {
    const updated = [...formData.description];
    updated.splice(index, 1);
    setFormData({ ...formData, description: updated });
  };

  const addFAQ = () => {
    setFormData({ ...formData, faqs: [...formData.faqs, { question: '', answer: '' }] });
  };

  const removeFAQ = (index) => {
    const updated = [...formData.faqs];
    updated.splice(index, 1);
    setFormData({ ...formData, faqs: updated });
  };
const handleAgePricingChange = (index, field, value) => {
  const updated = [...formData.age_based_pricing];
  updated[index][field] = value === '' ? null : Number(value);
  setFormData((prev) => ({ ...prev, age_based_pricing: updated }));
};

const addAgePricing = () => {
  setFormData((prev) => ({
    ...prev,
    age_based_pricing: [...prev.age_based_pricing, { min_age: null, max_age: null, price: 0 }],
  }));
};

const removeAgePricing = (index) => {
  const updated = [...formData.age_based_pricing];
  updated.splice(index, 1);
  setFormData((prev) => ({ ...prev, age_based_pricing: updated }));
};

  const handleSave = async () => {
    try {
      const payload = {
        ...formData,
        is_for_appointment: formData.is_for_appointment ? '1' : '0',
        active: formData.active ? '1' : '0',
        description: JSON.stringify(formData.description),
        faqs: JSON.stringify(formData.faqs),
        age_based_pricing: JSON.stringify(formData.age_based_pricing),

      };

      const response = await ApiServices.put(
        `/apis/default/api/membershipbenefits/${formData.id}`,
        payload,
        {
       
            Authorization: `Bearer ${accessToken}`,
          
        }
      );
      if (selectedImage) {
  try {
    await ApiServices.patch(
      `/apis/default/api/membershipbenefits/${formData.id}`,
      { base64_image: selectedImage },
      {
        
          Authorization: `Bearer ${accessToken}`,
        
      }
    );
  } catch (err) {
    console.error('Error uploading image:', err);
    alert('Benefit updated, but image upload failed.');
  }
}


      alert('Benefit updated successfully!');
    } catch (error) {
      console.error('Error updating benefit:', error);
      alert('Failed to update benefit.');
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h6" gutterBottom>Edit Benefit</Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Benefit Name"
            fullWidth
            value={formData.benefit_name}
            onChange={(e) => handleChange('benefit_name', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="Subtitle"
            fullWidth
            value={formData.subtitle}
            onChange={(e) => handleChange('subtitle', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.is_for_appointment}
                onChange={(e) => handleChange('is_for_appointment', e.target.checked)}
              />
            }
            label="Is For Appointment"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.active}
                onChange={(e) => handleChange('active', e.target.checked)}
              />
            }
            label="Active"
          />
        </Grid>
      </Grid>

      <Box mt={2}>
  {selectedImage || formData.image ? (
    <img
      src={selectedImage || formData.image}
      alt="Benefit"
      style={{ width: 200, height: 'auto', marginBottom: 8, borderRadius: 8 }}
    />
  ) : null}
  <Button variant="outlined" component="label">
    Upload Image
    <input type="file" accept="image/*" hidden onChange={handleImageChange} />
  </Button>
</Box>


      <Divider sx={{ my: 2 }} />
      <Typography variant="subtitle1">Descriptions</Typography>
      {formData?.description?.map((desc, idx) => (
        <Box key={idx} display="flex" alignItems="center" mb={1}>
          <TextField
            label={`Description ${idx + 1}`}
            fullWidth
            value={desc}
            onChange={(e) => handleDescriptionChange(idx, e.target.value)}
          />
          <IconButton onClick={() => removeDescription(idx)}>
            <Delete />
          </IconButton>
        </Box>
      ))}
      <Button startIcon={<Add />} onClick={addDescription}>
        Add Description
      </Button>

      <Divider sx={{ my: 2 }} />
      <Typography variant="subtitle1">FAQs</Typography>
      {formData?.faqs?.map((faq, idx) => (
        <Grid container spacing={1} alignItems="center" key={idx} mb={1}>
          <Grid item xs={5}>
            <TextField
              label="Question"
              fullWidth
              value={faq.question}
              onChange={(e) => handleFAQChange(idx, 'question', e.target.value)}
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              label="Answer"
              fullWidth
              value={faq.answer}
              onChange={(e) => handleFAQChange(idx, 'answer', e.target.value)}
            />
          </Grid>
          <Grid item xs={2}>
            <IconButton onClick={() => removeFAQ(idx)}>
              <Delete />
            </IconButton>
          </Grid>
        </Grid>
      ))}
      <Button startIcon={<Add />} onClick={addFAQ}>
        Add FAQ
      </Button>

      <Divider sx={{ my: 2 }} />
<Typography variant="subtitle1">Age Pricing</Typography>
{formData.age_based_pricing.map((item, idx) => (
  <Grid container spacing={1} alignItems="center" key={idx} mb={1}>
    <Grid item xs={3}>
      <TextField
        type="number"
        label="Min Age"
        fullWidth
        value={item.min_age ?? ''}
        onChange={(e) => handleAgePricingChange(idx, 'min_age', e.target.value)}
      />
    </Grid>
    <Grid item xs={3}>
      <TextField
        type="number"
        label="Max Age"
        fullWidth
        value={item.max_age ?? ''}
        onChange={(e) => handleAgePricingChange(idx, 'max_age', e.target.value)}
      />
    </Grid>
    <Grid item xs={4}>
      <TextField
        type="number"
        label="Price"
        fullWidth
        value={item.price}
        onChange={(e) => handleAgePricingChange(idx, 'price', e.target.value)}
      />
    </Grid>
    <Grid item xs={2}>
      <IconButton onClick={() => removeAgePricing(idx)}>
        <Delete />
      </IconButton>
    </Grid>
  </Grid>
))}
<Button startIcon={<Add />} onClick={addAgePricing}>
  Add Age Pricing
</Button>


      <Box mt={4}>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default BenefitsDetails;
